<template>
  <div class="per_query" @click="handleScreenClick">
    <router-link to="/">返回</router-link>
    <!--    <div v-html="renderedMarkdown" class="markdown-content"></div>-->
    <h2 class="blue_title">个人征信查询渠道</h2>
    <p class="content-text-indent">个人信用报告查询服务包括线上和线下方式。</p>
    <span class="blue_span">一、线上查询</span>
    <div>
      <p class="content-text-indent">（1）云闪付APP</p>
      <p class="content-text-indent">云闪付APP内搜索“信用报告查询”，点击“免费申请查询”。</p>
      <p class="content-text-indent">（2）中国人民银行征信中心网站</p>
      <p class="content-text-indent">登录<a href="#" class="copy-link" data-clipboard-text="www.pbccrc.org.cn">www.pbccrc.org.cn</a>（中国人民银行征信中心网站），点击 “核心业务”栏目下“互联网个人信用信息服务平台”入口查询。</p>
      <p class="content-text-indent">（3）手机银行APP</p>
      <p class="content-text-indent">已开通手机银行APP个人信用报告查询服务的金融机构有：</p>
      <div class="bank-images">
        <div class="bank-image" v-for="(bank, index) in bankImages" :key="index">
          <img :src="require(`@/assets/bank/${bank.image}`)" :alt="bank.name">
        </div>
      </div>
      <p class="content-text-indent">（4）网上银行</p>
      <p class="content-text-indent">已开通网上银行个人信用报告查询服务的金融机构有：</p>
      <div class="bank-images">
        <div class="bank-image" v-for="(bank, index) in onlineBankImages" :key="index">
          <img :src="require(`@/assets/bank/${bank.image}`)" :alt="bank.name">
        </div>
      </div>
      <p class="content-text-indent">中国工商银行、中国银行、中国建设银行、中国邮政储蓄银行、中信银行、中国民生银行、招商银行、广发银行、浦发银行。</p>
    </div>
    <span class="blue_span">二、线下查询</span>
    <div>
      <p class="content-text-indent">（1）自助机查询</p>
      <p class="content-text-indent">公众可携带有效证件前往布设信用报告自助查询机的商业银行网点进行自助查询。</p>
      <p class="content-text-indent">（2）智慧柜员机查询</p>
      <p class="content-text-indent">中国工商银行、中国建设银行、中国邮政储蓄银行等银行智慧柜员机上已开通个人信用报告查询服务（简版），满足社会公众的征信服务需求。公众可前往工商银行、建设银行、邮储银行网点查询。</p>
      <p class="content-text-indent">（3）人工柜台查询</p>
      <p class="content-text-indent">因特殊情况需要人工办理信用报告查询业务，可携带有效身份证件及相关材料就近选择征信人工查询柜台办理。</p>
    </div>
    <span class="blue_span">甘肃省各地分中心咨询电话：</span>
    <table class="contact-table">
      <thead>
        <tr>
          <th>地区</th>
          <th>咨询电话</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>兰州市</td>
          <td>0931-8800569</td>
        </tr>
        <tr>
          <td>嘉峪关市</td>
          <td>0937-6320014</td>
        </tr>
        <tr>
          <td>金昌市</td>
          <td>0935-8610551</td>
        </tr>
        <tr>
          <td>白银市</td>
          <td>0943-8269064</td>
        </tr>
        <tr>
          <td>天水市</td>
          <td>0938-8274257</td>
        </tr>
        <tr>
          <td>武威市</td>
          <td>0935-2262026</td>
        </tr>
        <tr>
          <td>张掖市</td>
          <td>0936-8257234</td>
        </tr>
        <tr>
          <td>平凉市</td>
          <td>0933-8268134</td>
        </tr>
        <tr>
          <td>酒泉市</td>
          <td>0937-2677084</td>
        </tr>
        <tr>
          <td>庆阳市</td>
          <td>0934-8628613</td>
        </tr>
        <tr>
          <td>定西市</td>
          <td>0932-8226359</td>
        </tr>
        <tr>
          <td>陇南市</td>
          <td>0939-8266161</td>
        </tr>
        <tr>
          <td>临夏回族自治州</td>
          <td>0930-6241070</td>
        </tr>
        <tr>
          <td>甘南藏族自治州</td>
          <td>0941-8250020</td>
        </tr>
      </tbody>
    </table>
    <div>
      <p class="small-text">中国人民银行征信中心客服电话：400-810-8866</p>
      <p class="small-text">
        中国人民银行征信中心官方网站：
        <a href="#" class="copy-link" data-clipboard-text="www.pbccrc.org.cn">www.pbccrc.org.cn</a>
      </p>
    </div>

    <transition name="slide-up">
      <div v-if="showFontSizeOptions" class="font-size-options">
        <div class="font-size-label">字体设置：</div>
        <div class="font-size-options-row">
          <div v-for="size in fontSizeOptions" :key="size"
               :class="{'font-size-option': true, 'selected': selectedFontSize === size}"
               @click="changeFontSize(size)"
          >
            {{ size }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it'
import ClipboardJS from 'clipboard'
export default {
  name: 'PerQueryVue',
  data () {
    return {
      showFontSizeOptions: false,
      selectedFontSize: '中',
      fontSizeOptions: ['小', '中', '大'],
      markdownContent: '',
      renderedMarkdown: '',
      bankImages: [
        { name: '中国工商银行', image: 'icbc.png' },
        { name: '中国农业银行', image: 'abc.png' },
        { name: '中国银行', image: 'boc.png' },
        { name: '中国建设银行', image: 'ccb.png' },
        { name: '交通银行', image: 'bocom.png' },
        { name: '中国邮政储蓄银行', image: 'psbc.png' },
        { name: '中信银行', image: 'citic.png' },
        { name: '中国光大银行', image: 'ceb.png' },
        { name: '华夏银行', image: 'hxb.png' },
        { name: '中国民生银行', image: 'cmbc.png' },
        { name: '招商银行', image: 'cmb.png' },
        { name: '广发银行', image: 'gdb.png' },
        { name: '平安银行', image: 'pab.png' },
        { name: '兴业银行', image: 'cib.png' },
        { name: '浦发银行', image: 'spdb.png' }
      ],
      onlineBankImages: [
        { name: '中国工商银行', image: 'icbc.png' },
        { name: '中国银行', image: 'boc.png' },
        { name: '中国建设银行', image: 'ccb.png' },
        { name: '中国邮政储蓄银行', image: 'psbc.png' },
        { name: '中信银行', image: 'citic.png' },
        { name: '中国民生银行', image: 'cmbc.png' },
        { name: '招商银行', image: 'cmb.png' },
        { name: '广发银行', image: 'gdb.png' },
        { name: '浦发银行', image: 'spdb.png' }
      ]
    }
  },
  mounted () {
    // 在组件挂载时渲染 Markdown 内容
    this.renderMarkdown()
    this.clipboard = new ClipboardJS('.copy-link')
    const this_ = this
    this.clipboard.on('success', function (e) {
      this_.$message({
        type: 'success',
        message: '复制成功'
      })
      e.clearSelection()
    })
    // 初始化字体设置
    const savedFontSize = localStorage.getItem('fontSize') || '中'
    this.selectedFontSize = savedFontSize
    document.documentElement.style.setProperty('--font-size', this.getFontSize(savedFontSize))
    document.documentElement.style.setProperty('--line-height', this.getLineHeight(savedFontSize))
  },
  beforeDestroy () {
    if (this.clipboard) {
      this.clipboard.destroy()
    }
  },
  methods: {
    renderMarkdown () {
      const md = new MarkdownIt()
      this.renderedMarkdown = md.render(this.markdownContent)
    },
    handleScreenClick (event) {
      // 检查点击的目标是否是字体设置抽屉中的元素
      const clickedElement = event.target
      const isInDrawer = clickedElement.closest('.font-size-options')

      // 如果点击的是字体设置选项或复制链接，则不切换抽屉显示状态
      if (isInDrawer || clickedElement.classList.contains('copy-link')) {
        return
      }

      // 切换字体设置抽屉的显示状态
      this.showFontSizeOptions = !this.showFontSizeOptions
    },
    changeFontSize (size) {
      this.selectedFontSize = size
      document.documentElement.style.setProperty('--font-size', this.getFontSize(size))
      document.documentElement.style.setProperty('--line-height', this.getLineHeight(size))
      // 保存字体设置到 localStorage
      localStorage.setItem('fontSize', size)
    },
    getFontSize (size) {
      switch (size) {
        case '小':
          return '14px'
        case '中':
          return '16px'
        case '大':
          return '18px'
        default:
          return '16px'
      }
    },
    getLineHeight (size) {
      switch (size) {
        case '小':
          return '1.5'
        case '中':
          return '1.8'
        case '大':
          return '2.0'
        default:
          return '1.8'
      }
    }
  }
}
</script>

<style scoped>
.per_query {
  padding: 20px;
  background-color: #f5f5f5;
}

.blue_title {
  text-align: center;
  font-size: var(--font-size, 20px);
  font-weight: normal;
  color: #3b88d6;
}

.blue_span {
  margin-top: 20px;
  font-size: var(--font-size, 14px);
  line-height: var(--line-height, 30px);
  color: #3b88d6;
}

.content-text-indent {
  text-indent: 2em;
  font-size: var(--font-size, 12px);
  margin: 0;
  color: #999;
  line-height: var(--line-height, 24px);
}

.contact-table {
  width: 100%;
  border-collapse: collapse;
}

.contact-table th, .contact-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  font-size: var(--font-size, 14px);
}

.contact-table th {
  background-color: #f2f2f2;
}

.small-text {
  font-size: var(--font-size, 14px);
}

.font-size-options {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.font-size-label {
  font-size: 16px;
  margin-bottom: 10px;
  text-align: left;
  padding-left: 10px;
}

.font-size-options-row {
  display: flex;
  justify-content: space-around;
  width: 100%;
}

.font-size-option {
  font-size: 16px;
  padding: 10px 20px;
  cursor: pointer;
  border: 2px solid transparent;
}

.font-size-option.selected {
  border-color: black;
}

.slide-up-enter-active, .slide-up-leave-active {
  transition: transform 0.3s ease;
}

.slide-up-enter, .slide-up-leave-to {
  transform: translateY(100%);
}

.bank-images {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.bank-image {
  flex: 0 1 calc(50% - 10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.bank-image img {
  width: 100px;
  height: 25px;
  border-radius: 8px;
  border: 1px solid #ccc;
  padding: 10px;
  background: white;
}
</style>
